import { Mail } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const links = [
    { href: "/promo#how", label: t.nav.how },
    { href: "/promo#menu", label: t.nav.menu },
    { href: "/promo#locations", label: t.nav.locations },
    { href: "/franchising", label: t.nav.franchise },
    { href: "/simulatore", label: t.nav.simulator },
  ];

  return (
    <footer className="bg-surface border-t border-line pt-16 pb-10" data-testid="site-footer">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-line">
          <div className="md:col-span-5">
            <Logo className="h-14" />
            <p className="mt-4 text-muted max-w-sm leading-relaxed">{f.tagline}</p>
            <p className="mt-6 text-sm text-muted">{f.company}</p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-5">{f.nav}</p>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-ink/70 hover:text-tricolor-green transition-colors duration-200" data-testid={`footer-nav-${l.label}`}>{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-5">{f.contact}</p>
            <ul className="space-y-3">
              {f.emails.map((em) => (
                <li key={em}>
                  <a href={`mailto:${em}`} className="flex items-center gap-2 text-sm text-ink/70 hover:text-tricolor-green transition-colors duration-200" data-testid={`footer-email-${em}`}>
                    <Mail size={15} /> {em}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-5">{f.certTitle}</p>
            <ul className="space-y-3">
              {f.certs.map((c) => (
                <li key={c} className="text-sm text-ink/70">{c}</li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-xs text-muted">{f.rights}</p>
      </div>
    </footer>
  );
};
